import React, { useEffect, useState, useRef } from "react";
import Switch from "@mui/material/Switch";
import BackdropComponent from "../../Spinner/Spinner";

import {
  Grid,
  Autocomplete,
  TextField,
  Card,
  Box,
  Tab,
  Tabs,
  Chip,
  InputAdornment,
  IconButton,
  Popper,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { CustomTooltip } from "components/RosterConfig/RosterConfigStyle";
import { GridSearchIcon } from "@mui/x-data-grid";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import SwapHorizontalCircleOutlinedIcon from "@mui/icons-material/SwapHorizontalCircleOutlined";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "components/AccordionComponents/AccordionComponents";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  getAllParentClients,
  getAllProjectsByParentClientCode,
  getWaveDetails,
  getClassRosterForAsdLead,
  searchEmployeeProfile,
  getClassRostersTaskType,
  getClassRostersScheduleType,
  getAllNoRosterIdClasses,
} from "../../../services/userServices";

import applicationUsageLog from "../../../utils/applicationUsagesLog";
import { CustomButton } from "../../../components/RosterConfig/RosterConfigStyle";
import SnackBar from "../../../components/SnackBar/SnackBar";
import Attendance from "../OMTBulkEdit/Attendance/Attendance";
import Hardware from "../OMTBulkEdit/Hardware/Hardware";
import TextLabel from "components/Common/TextLabel/TextLabel";
import Credentials from "../OMTBulkEdit/Credentials/Credentials";
import Network from "../OMTBulkEdit/Network/Network";
import OperatingSystem from "../OMTBulkEdit/OS/OS";
import Application from "../OMTBulkEdit/Application/Application";
import { useAuth } from "context/AuthContext";

export default function OMTClassSearch() {
  const defaultTheme = createTheme({
    palette: {
      primary: {
        main: "#3299FF",
      },
    },
  });
  const CustomPopper = (props) => {
    return <Popper {...props} placement="bottom-start" />;
  };
  const { hasPermission } = useAuth();

  const [editAccess, setEditAccess] = useState(false);
  const [isDisabledTaskType, setIsDisabledTaskType] = useState(true);
  const [expanded, setExpanded] = useState("panel1");
  const [tabIndex, setTabIndex] = useState(0);
  const [searchResults, setSearchResults] = useState([]);
  const [asdLeadOracleId, setAsdLeadOracleId] = useState(null);
  const [asdLeadName, setAsdLeadName] = useState("");
  const [searchCriteria, setSearchCriteria] = useState("");
  const [isASDAutocompleteOpen, setIsASDAutocompleteOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  const [isMaxRoster, setIsMaxRoster] = useState(false);

  const [optionTaskType, setOptionTaskType] = useState([]);
  const [taskType, setTaskType] = useState({
    OMTTaskTypeId: "",
    TaskTypeDescription: "",
  });

  const [optionScheduleType, setOptionScheduleType] = useState([]);

  const [scheduleType, setScheduleType] = useState([]);

  const [loading, setLoader] = useState(false);
  const [wave, setWave] = useState({
    Wave: "",
  });

  const [filterRosterData, setFilterRosterData] = useState([]);
  const [rosterValue, setRosterValue] = useState([]);
  const [rosterId, setRosterId] = useState(null);

  const [classMode, setClassMode] = useState("roster");
  const [uploadClassOptions, setUploadClassOptions] = useState([]);
  const [selectedUploadClass, setSelectedUploadClass] = useState([]);
  const [noRosterIdClassName, setNoRosterIdClassName] = useState(null);
  const [pendingUploadAgentIds, setPendingUploadAgentIds] = useState([]);

  const [projectOptions, setProjectOptions] = useState([]);
  const [project, setProject] = useState({
    ProjectName: "",
    ProjectCode: "",
  });
  const [waveOptions, setWaveOptions] = useState([]);
  const [parentClientOptions, setParentClientOptions] = useState([]);
  const [parentClient, setParentClient] = useState({
    ParentClientName: "",
  });

  const [snack, setSnack] = React.useState({
    open: false,
    message: "",
    severity: "",
  });

  const [agentOracleIds, setAgentOracleIds] = useState([]);
  const [agentSearchValue, setAgentSearchValue] = useState("");

  const [isDirty, setIsDirty] = useState(false);
  const [searchKey, setSearchKey] = useState(0);
  const [pendingTab, setPendingTab] = useState(null);
  const [pendingToggleEvent, setPendingToggleEvent] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const tabRefs = useRef(Array.from({ length: 6 }, () => React.createRef()));

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (classMode === "upload") return;
      try {
        const classRosterIds = rosterValue
          ?.map((item) => item.ClassRosterId)
          .join(",");

        if (classRosterIds != null && classRosterIds !== "") {
          await fetchClassRostersTaskType(classRosterIds);

          if (cancelled) return;

          await fetchClassRostersScheduleType(
            classRosterIds,
            taskType?.OMTTaskTypeId,
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch class roster data:", error);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [rosterValue, taskType]);

  const fetchClassRostersScheduleType = async (
    rosterId,
    taskTypeId,
    noRosterIdClassName,
  ) => {
    setLoader(true);

    try {
      const response = await getClassRostersScheduleType(
        rosterId ?? "",
        taskTypeId,
        noRosterIdClassName,
      );

      if (response?.data?.message === "Success") {
        setOptionScheduleType(response.data.data);
      } else {
        setOptionScheduleType([]);
      }
    } catch (error) {
      const is404 =
        error?.response?.status === 404 || error?.statusCode === 404;
      if (is404) {
        setOptionScheduleType([]);
      } else {
        errorHandler(true, "Some internal error occurred", "error");
      }
    } finally {
      setLoader(false);
    }
  };

  const fetchClassRostersTaskType = async (
    rosterValue,
    noRosterIdClassName,
  ) => {
    setLoader(true);
    try {
      const response = await getClassRostersTaskType(
        rosterValue,
        noRosterIdClassName,
      );
      if (response?.data?.message === "Success") {
        setOptionTaskType(response.data.data);
        setIsDisabledTaskType(false);
      } else {
        setOptionTaskType([]);
        setIsDisabledTaskType(true);
      }
    } catch (error) {
      const is404 =
        error?.response?.status === 404 || error?.statusCode === 404;
      if (is404) {
        setOptionTaskType([]);
        setIsDisabledTaskType(true);
      } else {
        errorHandler(true, "Some internal error occurred", "error");
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!selectedUploadClass || selectedUploadClass.length === 0) {
      if (classMode === "upload") {
        setOptionTaskType([]);
        setIsDisabledTaskType(true);
      }
      return;
    }
    fetchClassRostersTaskType(
      null,
      selectedUploadClass.map((c) => c.NoRosterIdClassName).join(","),
    );
  }, [selectedUploadClass, classMode]);

  useEffect(() => {
    if (!selectedUploadClass || selectedUploadClass.length === 0) return;
    fetchClassRostersScheduleType(
      null,
      taskType?.OMTTaskTypeId,
      selectedUploadClass.map((c) => c.NoRosterIdClassName).join(","),
    );
  }, [selectedUploadClass, taskType]);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (classMode === "upload") return;
      try {
        const agentOracleIdString = agentOracleIds.join(",");

        await fetchClassRosters(
          project?.ProjectCode ?? "",
          wave?.Wave ?? "",
          asdLeadOracleId ?? "",
          agentOracleIdString,
        );

        if (!cancelled) {
          setRosterValue([]);
          setIsMaxRoster(false);
          setRosterId(null);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch class rosters:", error);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [project, wave, asdLeadOracleId]);

  const fetchClassRosters = async (
    ProjectCode = "",
    wave = "",
    asdLeadOracleId = "",
    agentOracleId = "",
  ) => {
    setLoader(true);
    try {
      const params = {
        projectCode: ProjectCode || null,
        wave: wave || null,
        asdLeadOracleId: asdLeadOracleId || null,
        agentOracleId: agentOracleId || null,
      };

      const response = await getClassRosterForAsdLead(
        params.projectCode,
        params.wave,
        params.asdLeadOracleId,
        params.agentOracleId,
      );

      if (response?.data?.message === "Success") {
        setFilterRosterData(response.data.data);
        setRosterValue([]);
        setIsMaxRoster(false);
        setRosterId(null);
      } else {
        setFilterRosterData([]);
        setRosterValue([]);
        errorHandler(
          true,
          "Class roster could not be fetched, please add trainee from Class Setup",
          "error",
        );
      }
    } catch (error) {
      console.error("Error fetching class rosters:", error);
      setFilterRosterData([]);
      errorHandler(true, "Some internal error occurred", "error");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      try {
        if (!cancelled) {
          setEditAccess(hasPermission("ASD_Group"));
        }

        await fetchData();

        if (!cancelled) {
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "obtinfo",
            "Class Roster Search",
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to initialize:", error);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, [hasPermission]);

  const fetchData = async () => {
    setLoader(true);
    try {
      const parentClientResponse = await getAllParentClients();
      if (parentClientResponse?.data?.message === "Success") {
        setParentClientOptions(parentClientResponse?.data?.data);
      } else {
        errorHandler(true, "No Parent Clients Found...", "error");
      }

      const classRosterResponse = await getClassRosterForAsdLead();
      if (classRosterResponse?.data?.message === "Success") {
        setFilterRosterData(classRosterResponse?.data?.data);
      } else {
        errorHandler(true, "No Roster Data Found...", "error");
      }
    } catch {
      errorHandler(true, "Some internal error occurred.", "error");
    }
    setLoader(false);
  };

  const handleAgentSearchClick = async () => {
    const trimmedValue = agentSearchValue.trim();

    if (trimmedValue === "") {
      setSnack({
        open: true,
        message: "Please enter an Oracle ID to search",
        severity: "error",
      });
      return;
    }

    const oracleIds = trimmedValue
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id.length > 0);

    const invalidIds = oracleIds.filter((id) => id.length < 3);
    if (invalidIds.length > 0) {
      setSnack({
        open: true,
        message: "Oracle ID must be at least 3 characters",
        severity: "error",
      });
      return;
    }

    if (classMode === "upload") {
      setPendingUploadAgentIds(oracleIds);
      setNoRosterIdClassName(null);
      setSelectedUploadClass([]);
      const result = await reloadUploadClassOptions(
        asdLeadOracleId || null,
        oracleIds.join(","),
        true,
      );
      if (result && result.length > 0) {
        setAgentOracleIds(oracleIds);
        setNoRosterIdClassName(
          result.map((c) => c.NoRosterIdClassName).join(","),
        );
        setExpanded("panel2");
      }
      return;
    }

    setAgentOracleIds(oracleIds);

    setSnack({
      open: true,
      message: `Fetching rosters for ${oracleIds.length} agent(s): ${oracleIds.join(", ")}`,
      severity: "info",
    });

    try {
      await fetchClassRosters(
        project?.ProjectCode ?? "",
        wave?.Wave ?? "",
        asdLeadOracleId ?? "",
        oracleIds.join(","),
      );
    } catch (error) {
      console.error("Error fetching rosters for agents:", error);
    }
  };

  const handleAgentInputChange = (event) => {
    const value = event.target.value;
    setAgentSearchValue(value);
    if (value === "") {
      if (classMode === "upload") {
        setPendingUploadAgentIds([]);
        setNoRosterIdClassName(null);
        reloadUploadClassOptions(asdLeadOracleId || null, null, true);
      } else {
        setAgentOracleIds([]);
      }
    }
  };

  const handleParentClientChange = async (event, value) => {
    setLoader(true);
    setParentClient(value);
    setProject({
      ProjectName: "",
      ProjectCode: "",
    });
    setWave({
      Wave: "",
    });
    try {
      if (value !== null) {
        const clientResponse = await getAllProjectsByParentClientCode(
          value?.ParentClientCode,
        );
        if (clientResponse?.data?.message === "Success") {
          setProjectOptions(clientResponse?.data?.data);
          setWaveOptions([]);
        } else {
          errorHandler(true, "No data Found..", "error");
        }
      } else {
        setProjectOptions([]);
        setWaveOptions([]);
      }
    } catch {
      errorHandler(true, "Some internal error occurred.", "error");
    }
    setLoader(false);
  };

  const handleProjectChange = async (event, value) => {
    setLoader(true);
    setProject(value);
    setWave({
      Wave: "",
    });

    try {
      if (value !== null) {
        const waveResponse = await getWaveDetails(value?.ProjectCode);
        if (waveResponse?.data?.message === "Success") {
          setWaveOptions(waveResponse?.data?.data);
        } else {
          errorHandler(true, "Waves could not be fetched.", "error");
        }
      } else {
        setWaveOptions([]);
      }
    } catch {
      errorHandler(true, "Some internal error occurred.", "error");
    }
    setLoader(false);
  };

  const errorHandler = (open, message, severity) => {
    setSnack({
      open: true,
      message: message,
      severity: severity,
    });
  };
  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleChangePanel = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleTabChange = (event, newIndex) => {
    if (newIndex === tabIndex) return;
    if (isDirty) {
      setPendingTab(newIndex);
      setShowDialog(true);
    } else {
      setTabIndex(newIndex);
      setIsDirty(false);
    }
  };

  const handleDialogSave = async () => {
    const success = await tabRefs.current[tabIndex]?.current?.save();
    setShowDialog(false);
    if (success !== false) {
      setIsDirty(false);
      if (pendingToggleEvent !== null) {
        if (success === true) {
          setSnack({
            open: true,
            message: "All changes have been saved Successfully.",
            severity: "success",
          });
        }
        await applyToggleChange(pendingToggleEvent);
        setPendingToggleEvent(null);
      } else {
        setTabIndex(pendingTab);
        setPendingTab(null);
      }
    }
  };

  const handleDialogDiscrad = () => {
    setShowDialog(false);
    setIsDirty(false);
    if (pendingToggleEvent !== null) {
      applyToggleChange(pendingToggleEvent);
      setPendingToggleEvent(null);
    } else {
      setTabIndex(pendingTab);
      setPendingTab(null);
    }
  };

  const handleDialogCancel = () => {
    setShowDialog(false);
    setPendingTab(null);
  };

  const handleSearch = async () => {
    if (classMode === "upload") {
      if (!selectedUploadClass || selectedUploadClass.length === 0) {
        setSnack({
          open: true,
          message: "Please select an uploaded class.",
          severity: "error",
        });
        return;
      }
      if (pendingUploadAgentIds.length > 0) {
        setAgentOracleIds(pendingUploadAgentIds);
      }
      setNoRosterIdClassName(
        selectedUploadClass.map((c) => c.NoRosterIdClassName).join(","),
      );
      setSearchKey((k) => k + 1);
      setExpanded("panel2");
      return;
    }

    const classRosterIds = rosterValue
      ?.map((item) => item.ClassRosterId)
      .join(",");

    const agentIdString = agentOracleIds.join(",");

    if (agentIdString && agentIdString !== "") {
      console.log("Agent search - skipping roster validation");
      setRosterId(classRosterIds === "" ? null : classRosterIds);
      setExpanded("panel2");
      if (agentSearchValue.trim() && !agentOracleIds) {
        setAgentOracleIds(agentSearchValue.trim());
      }

      return;
    }

    if (classRosterIds === "") {
      setSnack({
        open: true,
        message: "Please select at least one class roster.",
        severity: "error",
      });
      return;
    }

    setRosterId(classRosterIds);
    setExpanded("panel2");
  };

  const handleClear = () => {
    setParentClient(null);
    setWave(null);
    setProject(null);
    setRosterValue([]);
    setRosterId(null);
    setAsdLeadOracleId(null);
    setAsdLeadName("");
    setSearchResults([]);
    setSearchCriteria("");
    setAgentOracleIds([]);
    setAgentSearchValue("");
    setOptionTaskType([]);
    setIsMaxRoster(false);
    setTaskType({
      OMTTaskTypeId: "",
      TaskTypeDescription: "",
    });
    setOptionScheduleType([]);
    setScheduleType([]);
    setFilterRosterData([]);
    setSelectedLead(null);
    setSelectedUploadClass([]);
    setNoRosterIdClassName(null);
    setPendingUploadAgentIds([]);
    if (classMode === "upload") {
      reloadUploadClassOptions(null, null, true);
    }
  };

  const reloadUploadClassOptions = async (
    asdLead = null,
    oracleId = null,
    silent = false,
  ) => {
    setLoader(true);
    try {
      const response = await getAllNoRosterIdClasses(asdLead, oracleId);
      if (response?.data?.message === "Success") {
        setUploadClassOptions(response.data.data);
        if (!silent) {
          const count = response.data.data.length;
          setSnack({
            open: true,
            message: `Found ${count} uploaded class${count !== 1 ? "es" : ""} matching the selected filters.`,
            severity: "success",
          });
        }
        return response.data.data;
      } else {
        setUploadClassOptions([]);
        if (!silent) {
          setSnack({
            open: true,
            message: "No uploaded classes found for the selected filters.",
            severity: "info",
          });
        }
        return [];
      }
    } catch (error) {
      const is404 =
        error?.response?.status === 404 || error?.statusCode === 404;
      if (is404) {
        setUploadClassOptions([]);
        if (!silent) {
          setSnack({
            open: true,
            message: "No uploaded classes found for the selected filters.",
            severity: "info",
          });
        }
        return [];
      } else {
        errorHandler(true, "Some internal error occurred.", "error");
        return [];
      }
    } finally {
      setLoader(false);
    }
  };

  const handleToggleChange = async (event) => {
    const isUpload = event.target.checked;
    if (isDirty) {
      setPendingToggleEvent(isUpload);
      setShowDialog(true);
      return;
    }
    await applyToggleChange(isUpload);
  };

  const applyToggleChange = async (isUpload) => {
    setClassMode(isUpload ? "upload" : "roster");
    setRosterId(null);
    setNoRosterIdClassName(null);
    setSelectedUploadClass([]);
    setRosterValue([]);
    setAgentOracleIds([]);
    setPendingUploadAgentIds([]);
    setAgentSearchValue("");
    setAsdLeadOracleId(null);
    setAsdLeadName("");
    setSelectedLead(null);
    setSearchResults([]);
    setTaskType({ OMTTaskTypeId: "", TaskTypeDescription: "" });
    setScheduleType([]);
    setOptionTaskType([]);
    setOptionScheduleType([]);
    setIsDisabledTaskType(true);
    setIsDirty(false);
    setTabIndex(0);
    setExpanded("panel1");
    if (isUpload) {
      await reloadUploadClassOptions(null, null, true);
    } else {
      setUploadClassOptions([]);
    }
  };

  const handleInputChange = (event, newInputValue) => {
    if (newInputValue === "") {
      setAsdLeadOracleId(null);
      setAsdLeadName("");
    }
  };

  const handleValueChange = (name, value) => {
    setSearchCriteria(value);
  };

  const handleASDSearch = async (event, searchQuery) => {
    if (searchQuery.length < 3) {
      setSnack({
        open: true,
        message: "Search criteria must be at least 3 characters in length.",
        severity: "error",
      });
      return;
    }
    setLoader(true);
    const searchResult = await searchEmployeeProfile(searchQuery);
    if (searchResult.status === true) {
      let searchResultDetails;

      if (/^\d+$/.test(searchQuery) && searchQuery.length >= 4) {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display:
            (emp.Name ?? "") + (emp.OracleId ? ` (${emp.OracleId})` : ""),
          Name: emp.Name,
          Email: emp.Email,
        }));
      } else {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display: emp.Display,
          Name: emp.Name,
          Email: emp.Email,
        }));
      }

      setSearchResults(searchResultDetails);
      setAsdLeadOracleId(searchResultDetails[0]?.OracleId || null);
      setAsdLeadName(searchResultDetails[0]?.Name || "");
      setLoader(false);
      setSnack({
        open: true,
        message: "We found results matching the search criteria.",
        severity: "success",
      });
    } else {
      setSnack({
        open: true,
        message: "No result found matching with search criteria.",
        severity: "error",
      });
      setLoader(false);
    }
  };

  const TAB_LABELS = [
    "Attendance",
    "Hardware",
    "AD Credentials",
    "Network",
    "OS",
    "Application",
  ];

  const tabProps = (index) => ({
    ref: tabRefs.current[index],
    onDirtyChange: setIsDirty,
    rosterId,
    asdLeadOracleId,
    agentOracleId: agentOracleIds.join(","),
    taskTypeId: taskType?.OMTTaskTypeId,
    scheduleType: scheduleType.map((s) => s.ScheduleType).join(","),
    editAccess,
    noRosterIdClassName,
    isUploadMode: classMode === "upload",
    isNoRosterIdSearch: classMode === "upload" ? "True" : null,
    searchKey,
  });

  return (
    <>
      {loading ? <BackdropComponent /> : null}

      <ThemeProvider theme={defaultTheme}>
        <Card
          sx={{
            height: "calc(100vh - 80px)",
            width: "calc(100vw - 125px)",
            overflowY: "auto",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChangePanel("panel1")}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <TextLabel
                      text={
                        classMode === "upload"
                          ? "Uploaded Class Search"
                          : "Class Roster Search"
                      }
                      fontSize={16}
                    />
                    <Box
                      sx={{
                        ml: "auto",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mr: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: classMode === "roster" ? 600 : 400,
                          color:
                            classMode === "roster"
                              ? "text.primary"
                              : "text.secondary",
                        }}
                      >
                        Class Roster
                      </Typography>
                      <Switch
                        size="small"
                        checked={classMode === "upload"}
                        onChange={handleToggleChange}
                        color="primary"
                      />
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: classMode === "upload" ? 600 : 400,
                          color:
                            classMode === "upload"
                              ? "text.primary"
                              : "text.secondary",
                        }}
                      >
                        Uploaded Class
                      </Typography>
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  {classMode === "upload" ? (
                    <Grid container rowGap={0.4}>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Uploaded Class"} />
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              multiple
                              size="small"
                              disablePortal
                              options={uploadClassOptions}
                              value={selectedUploadClass || []}
                              getOptionLabel={(option) =>
                                option?.NoRosterIdClassName ?? ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                option?.NoRosterIdClassName ===
                                value?.NoRosterIdClassName
                              }
                              renderTags={(value) => [
                                <Chip
                                  key="tag"
                                  label={value[0]?.NoRosterIdClassName}
                                  size="small"
                                  onDelete={() => {
                                    const next = value.slice(1);
                                    setSelectedUploadClass(next);
                                    if (next.length === 0) {
                                      setOptionTaskType([]);
                                      setOptionScheduleType([]);
                                      setIsDisabledTaskType(true);
                                    }
                                  }}
                                  sx={{
                                    mr: 0.5,
                                    backgroundColor: "#E3F2FD",
                                    color: "#3299FF",
                                    "& .MuiChip-deleteIcon": {
                                      color: "#3299FF",
                                    },
                                  }}
                                />,
                                value.length > 1 && (
                                  <CustomTooltip
                                    key="more-tooltip"
                                    title={value
                                      .map((c) => c.NoRosterIdClassName)
                                      .join(", ")}
                                  >
                                    <Chip
                                      key="more"
                                      label={`+${value.length - 1}`}
                                      size="small"
                                      sx={{
                                        backgroundColor: "#3299FF",
                                        color: "white",
                                        fontWeight: 600,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </CustomTooltip>
                                ),
                              ]}
                              onChange={(event, value) => {
                                if (value.length > 3) return;
                                setSelectedUploadClass(value);
                                if (!value || value.length === 0) {
                                  setOptionTaskType([]);
                                  setOptionScheduleType([]);
                                  setIsDisabledTaskType(true);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder={
                                    selectedUploadClass?.length
                                      ? ""
                                      : "Select or type class name"
                                  }
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2} />
                        </Grid>
                      </Grid>
                      <Grid item xs={9} />

                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"ASD Lead"} />
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              options={searchResults}
                              value={selectedLead}
                              onInputChange={handleInputChange}
                              onChange={(event, value) => {
                                if (value) {
                                  setSelectedLead(value);
                                  const id =
                                    value.OracleId || value.Display || "";
                                  setAsdLeadOracleId(id);
                                  if (classMode === "upload") {
                                    setNoRosterIdClassName(null);
                                    reloadUploadClassOptions(
                                      id,
                                      pendingUploadAgentIds.length > 0
                                        ? pendingUploadAgentIds.join(",")
                                        : null,
                                      true,
                                    );
                                  }
                                } else {
                                  setAsdLeadOracleId(null);
                                  setAsdLeadName("");
                                  setSelectedLead(null);
                                  setSearchResults([]);
                                  if (classMode === "upload") {
                                    setNoRosterIdClassName(null);
                                    reloadUploadClassOptions(
                                      null,
                                      pendingUploadAgentIds.length > 0
                                        ? pendingUploadAgentIds.join(",")
                                        : null,
                                      true,
                                    );
                                  }
                                }
                              }}
                              PopperComponent={CustomPopper}
                              open={
                                isASDAutocompleteOpen &&
                                searchResults.length > 0
                              }
                              onOpen={() => setIsASDAutocompleteOpen(true)}
                              onClose={() => setIsASDAutocompleteOpen(false)}
                              getOptionLabel={(option) => option.Display || ""}
                              renderInput={(params) => (
                                <TextField
                                  name="asdLead"
                                  {...params}
                                  size="small"
                                  placeholder="Oracle ID or Name or Email"
                                  value={asdLeadName || ""}
                                  onChange={(event) =>
                                    handleValueChange(
                                      event.target.name,
                                      event.target.value,
                                    )
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      event.preventDefault();
                                      if (searchCriteria.trim().length >= 3) {
                                        handleASDSearch(event, searchCriteria);
                                        setIsASDAutocompleteOpen(true);
                                      }
                                    }
                                  }}
                                  sx={{ minWidth: 120 }}
                                  InputProps={{
                                    maxLength: 50,
                                    ...params.InputProps,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <CustomTooltip title="Search">
                                          <IconButton
                                            type="button"
                                            onClick={(event) =>
                                              handleASDSearch(
                                                event,
                                                searchCriteria,
                                              )
                                            }
                                          >
                                            <GridSearchIcon />
                                          </IconButton>
                                        </CustomTooltip>
                                        {params.InputProps.endAdornment}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2} />
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Agent Search"} />
                          </Grid>
                          <Grid item xs={10}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Enter Agent Oracle ID(comma-separated)"
                              value={agentSearchValue}
                              onChange={handleAgentInputChange}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  handleAgentSearchClick();
                                }
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <CustomTooltip title="Search Agent">
                                      <span>
                                        <IconButton
                                          type="button"
                                          onClick={handleAgentSearchClick}
                                          disabled={!agentSearchValue.trim()}
                                        >
                                          <GridSearchIcon />
                                        </IconButton>
                                      </span>
                                    </CustomTooltip>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={2} sx={{ pt: 0.2, pl: 1.8 }}>
                            <ArrowCircleRightOutlinedIcon
                              sx={{
                                color: (
                                  classMode === "upload"
                                    ? pendingUploadAgentIds.length > 0
                                    : agentOracleIds.length > 0
                                )
                                  ? "#3299FF"
                                  : "#CCCCCC",
                                fontSize: 28,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Task Type"} />
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              key={
                                selectedUploadClass?.length > 0
                                  ? selectedUploadClass
                                      .map((c) => c.NoRosterIdClassName)
                                      .join("-")
                                  : "no-class"
                              }
                              disabled={
                                classMode === "upload"
                                  ? selectedUploadClass.length === 0
                                  : isDisabledTaskType
                              }
                              disablePortal
                              options={optionTaskType}
                              getOptionLabel={(option) =>
                                option?.TaskTypeDescription
                                  ? `${option.TaskTypeDescription} (${option.OMTTaskTypeId})`
                                  : ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                option?.OMTTaskTypeId === value?.OMTTaskTypeId
                              }
                              value={taskType?.OMTTaskTypeId ? taskType : null}
                              onChange={(event, value) => {
                                setTaskType(
                                  value ?? {
                                    OMTTaskTypeId: "",
                                    TaskTypeDescription: "",
                                  },
                                );
                                if (value?.OMTTaskTypeId) {
                                  fetchClassRostersScheduleType(
                                    null,
                                    value.OMTTaskTypeId,
                                    selectedUploadClass
                                      .map((c) => c.NoRosterIdClassName)
                                      .join(","),
                                  );
                                } else {
                                  setOptionScheduleType([]);
                                  setScheduleType([]);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select Task"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2} />
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid item xs={12}>
                          <TextLabel
                            text={"Schedule(Schedule,EXT,Recovery,PERR)"}
                          />
                        </Grid>
                        <Grid item xs={11}>
                          <Autocomplete
                            disablePortal
                            multiple
                            disabled={
                              classMode === "upload"
                                ? selectedUploadClass.length === 0
                                : false
                            }
                            options={optionScheduleType}
                            getOptionLabel={(option) =>
                              option?.ScheduleType || ""
                            }
                            value={scheduleType}
                            onChange={(event, value) => {
                              const allOption = value.find(
                                (option) =>
                                  option?.ScheduleType?.toLowerCase() === "all",
                              );
                              if (allOption) {
                                setScheduleType([allOption]);
                                setSnack({
                                  open: true,
                                  message:
                                    "When 'All' is selected, other options are cleared. Remove 'All' to select specific schedule types.",
                                  severity: "info",
                                });
                              } else {
                                setScheduleType(value);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                placeholder="Select Schedule (Schedule,EXT,Recovery,PERR)"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={1} />
                      </Grid>

                      <Grid item xs={10.5} />
                      <Grid item xs={0.5} sx={{ pt: 1 }}>
                        <CustomButton
                          variant="contained"
                          sx={{
                            color: "white",
                            backgroundColor: "#3299FF",
                            "&:hover": { backgroundColor: "#2878CC" },
                          }}
                          onClick={handleSearch}
                        >
                          Search
                        </CustomButton>
                      </Grid>
                      <Grid item xs={0.5} sx={{ pt: 1 }}>
                        <CustomButton
                          variant="outlined"
                          sx={{
                            marginLeft: "30px",
                            borderColor: "#3299FF",
                            color: "#3299FF",
                            "&:hover": {
                              borderColor: "#3299FF",
                              backgroundColor: "#E0F2FF",
                            },
                          }}
                          onClick={handleClear}
                        >
                          Clear
                        </CustomButton>
                      </Grid>
                      <Grid item xs={1} />
                    </Grid>
                  ) : (
                    <Grid container rowGap={0.4}>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Class Roster"}></TextLabel>
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              size="small"
                              disablePortal
                              multiple
                              options={filterRosterData}
                              value={rosterValue}
                              getOptionLabel={(option) =>
                                option?.ClassRosterId &&
                                option?.RosterStatus &&
                                option?.Wave
                                  ? `${option?.ClassRosterId} - ${option?.RosterStatus} (${option?.Wave})`
                                  : ""
                              }
                              onChange={(event, value) => {
                                if (value.length === 0) {
                                  setRosterValue([]);
                                  setIsMaxRoster(false);
                                } else if (value.length <= 3) {
                                  setRosterValue(value);
                                  setIsMaxRoster(false);
                                } else {
                                  setIsMaxRoster(true);
                                }
                              }}
                              renderTags={(value) => [
                                <Chip
                                  key="tag"
                                  label={
                                    value[0]?.ClassRosterId &&
                                    value[0]?.RosterStatus &&
                                    value[0]?.Wave
                                      ? `${value[0].ClassRosterId} - ${value[0].RosterStatus} (${value[0].Wave})`
                                      : ""
                                  }
                                  size="small"
                                  onDelete={() => {
                                    const next = value.slice(1);
                                    setRosterValue(next);
                                    setIsMaxRoster(false);
                                  }}
                                  sx={{
                                    mr: 0.5,
                                    backgroundColor: "#E3F2FD",
                                    color: "#3299FF",
                                    "& .MuiChip-deleteIcon": {
                                      color: "#3299FF",
                                    },
                                  }}
                                />,
                                value.length > 1 && (
                                  <CustomTooltip
                                    key="more-tooltip"
                                    title={value
                                      .map((r) =>
                                        r?.ClassRosterId &&
                                        r?.RosterStatus &&
                                        r?.Wave
                                          ? `${r.ClassRosterId} - ${r.RosterStatus} (${r.Wave})`
                                          : "",
                                      )
                                      .join(", ")}
                                  >
                                    <Chip
                                      key="more"
                                      label={`+${value.length - 1}`}
                                      size="small"
                                      sx={{
                                        backgroundColor: "#3299FF",
                                        color: "white",
                                        fontWeight: 600,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </CustomTooltip>
                                ),
                              ]}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select RosterID - Status - Wave"
                                />
                              )}
                            />
                            {isMaxRoster && (
                              <Box sx={{ color: "red", marginTop: "10px" }}>
                                You can select up to 3 rosters only.
                              </Box>
                            )}
                          </Grid>
                          <Grid item xs={2} sx={{ pt: 0.2, pl: 1.8 }}>
                            <SwapHorizontalCircleOutlinedIcon
                              sx={{
                                color: "#3299FF",
                                fontSize: 28,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Parent Client"}></TextLabel>
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              size="small"
                              disablePortal
                              options={parentClientOptions}
                              value={parentClient}
                              onChange={handleParentClientChange}
                              getOptionLabel={(option) =>
                                option?.ParentClientName === ""
                                  ? ""
                                  : `${
                                      option?.ParentClientName +
                                      " (" +
                                      option?.ParentClientCode +
                                      ")"
                                    }`
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select Parent Client"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2} sx={{ pt: 0.2, pl: 1.8 }}>
                            <ArrowCircleRightOutlinedIcon
                              sx={{
                                color: "#3299FF",
                                fontSize: 28,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Project"}></TextLabel>
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              size="small"
                              disablePortal
                              blurOnSelect
                              options={projectOptions}
                              value={project}
                              onChange={handleProjectChange}
                              getOptionLabel={(option) =>
                                option?.ProjectName === "" &&
                                option?.ProjectCode === ""
                                  ? ""
                                  : `${
                                      option?.ProjectName +
                                      " (" +
                                      option?.ProjectCode +
                                      ")"
                                    }`
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select Project"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2} sx={{ pt: 0.2, pl: 1.8 }}>
                            <ArrowCircleRightOutlinedIcon
                              sx={{
                                color: "#3299FF",
                                fontSize: 28,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Wave"}></TextLabel>
                          </Grid>
                          <Grid item xs={11}>
                            <Autocomplete
                              size="small"
                              disablePortal
                              blurOnSelect
                              options={waveOptions}
                              value={wave}
                              onChange={(e, inputValue) => setWave(inputValue)}
                              getOptionLabel={(option) =>
                                option?.Wave === "" ? "" : `${option?.Wave}`
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select Wave"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={1}></Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"ASD Lead"}></TextLabel>
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              options={searchResults}
                              value={selectedLead}
                              onInputChange={handleInputChange}
                              onChange={(event, value) => {
                                if (value) {
                                  setSelectedLead(value);
                                  const asdLeadOracleId =
                                    value.OracleId || value.Display || "";
                                  setAsdLeadOracleId(asdLeadOracleId);

                                  fetchClassRosters(
                                    project?.ProjectCode ?? "",
                                    wave?.Wave ?? "",
                                    asdLeadOracleId,
                                    agentOracleIds.join(","),
                                  );

                                  setRosterValue([]);
                                  setIsMaxRoster(false);
                                  setRosterId(null);
                                } else {
                                  setAsdLeadOracleId(null);
                                  setAsdLeadName("");
                                  setSelectedLead(null);
                                  setSearchResults([]);
                                }
                              }}
                              PopperComponent={CustomPopper}
                              open={
                                isASDAutocompleteOpen &&
                                searchResults.length > 0
                              }
                              onOpen={() => setIsASDAutocompleteOpen(true)}
                              onClose={() => setIsASDAutocompleteOpen(false)}
                              getOptionLabel={(option) => option.Display || ""}
                              renderInput={(params) => (
                                <TextField
                                  name="asdLead"
                                  {...params}
                                  size="small"
                                  placeholder="Oracle ID or Name or Email"
                                  value={asdLeadName || ""}
                                  onChange={(event) =>
                                    handleValueChange(
                                      event.target.name,
                                      event.target.value,
                                    )
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      event.preventDefault();
                                      if (searchCriteria.trim().length >= 3) {
                                        handleASDSearch(event, searchCriteria);
                                        setIsASDAutocompleteOpen(true);
                                      }
                                    }
                                  }}
                                  sx={{ minWidth: 120 }}
                                  InputProps={{
                                    maxLength: 50,
                                    ...params.InputProps,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <CustomTooltip title="Search">
                                          <IconButton
                                            id="icon-button-search"
                                            type="button"
                                            onClick={(event) =>
                                              handleASDSearch(
                                                event,
                                                searchCriteria,
                                              )
                                            }
                                          >
                                            <GridSearchIcon />
                                          </IconButton>
                                        </CustomTooltip>
                                        {params.InputProps.endAdornment}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2}></Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Agent Search"}></TextLabel>
                          </Grid>
                          <Grid item xs={10}>
                            <TextField
                              size="small"
                              fullWidth
                              placeholder="Enter Agent Oracle ID(comma-separated)"
                              value={agentSearchValue}
                              onChange={handleAgentInputChange}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  handleAgentSearchClick();
                                }
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <CustomTooltip title="Search Agent">
                                      <span>
                                        <IconButton
                                          id="icon-button-agent-search"
                                          type="button"
                                          onClick={handleAgentSearchClick}
                                          disabled={!agentSearchValue.trim()}
                                        >
                                          <GridSearchIcon />
                                        </IconButton>
                                      </span>
                                    </CustomTooltip>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={2} sx={{ pt: 0.2, pl: 1.8 }}>
                            <ArrowCircleRightOutlinedIcon
                              sx={{
                                color:
                                  agentOracleIds.length > 0
                                    ? "#3299FF"
                                    : "#CCCCCC",
                                fontSize: 28,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextLabel text={"Task Type"}></TextLabel>
                          </Grid>
                          <Grid item xs={10}>
                            <Autocomplete
                              disabled={isDisabledTaskType}
                              disablePortal
                              options={optionTaskType}
                              getOptionLabel={(option) =>
                                option?.TaskTypeDescription === "" &&
                                option?.OMTTaskTypeId === ""
                                  ? ""
                                  : `${option?.TaskTypeDescription} (${option?.OMTTaskTypeId})`
                              }
                              value={taskType}
                              onChange={(event, value) => {
                                setTaskType(value);
                                setRosterId(null);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select Task"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2}></Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={3}>
                        <Grid item xs={12}>
                          <TextLabel
                            text={"Schedule(Schedule,EXT,Recovery,PERR)"}
                          ></TextLabel>
                        </Grid>
                        <Grid item xs={11}>
                          <Autocomplete
                            disablePortal
                            multiple
                            options={optionScheduleType}
                            getOptionLabel={(option) =>
                              option?.ScheduleType || ""
                            }
                            value={scheduleType}
                            onChange={(event, value, reason) => {
                              const allOption = value.find(
                                (option) =>
                                  option?.ScheduleType?.toLowerCase() === "all",
                              );

                              if (allOption) {
                                setScheduleType([allOption]);
                                setSnack({
                                  open: true,
                                  message:
                                    "When 'All' is selected, other options are cleared. Remove 'All' to select specific schedule types.",
                                  severity: "info",
                                });
                              } else {
                                setScheduleType(value);
                              }
                              setRosterId(null);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                placeholder="Select Schedule (Schedule,EXT,Recovery,PERR)"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={1}></Grid>
                      </Grid>

                      <Grid item xs={10.5}></Grid>
                      <Grid item xs={0.5} sx={{ pt: 1 }}>
                        <CustomButton
                          variant="contained"
                          sx={{
                            color: "white",
                            backgroundColor: "#3299FF",
                            "&:hover": {
                              backgroundColor: "#2878CC",
                            },
                          }}
                          onClick={handleSearch}
                        >
                          Search
                        </CustomButton>
                      </Grid>
                      <Grid item xs={0.5} sx={{ pt: 1 }}>
                        <CustomButton
                          variant="outlined"
                          sx={{
                            marginLeft: "30px",
                            borderColor: "#3299FF",
                            color: "#3299FF",
                            "&:hover": {
                              borderColor: "#3299FF",
                              backgroundColor: "#E0F2FF",
                            },
                          }}
                          onClick={handleClear}
                        >
                          Clear
                        </CustomButton>
                      </Grid>

                      <Grid item xs={1}></Grid>
                    </Grid>
                  )}
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={tabIndex}
                    textColor="primary"
                    indicatorColor="primary"
                    onChange={handleTabChange}
                  >
                    <Tab label="Attendance"></Tab>
                    <Tab label="Hardware"></Tab>
                    <Tab label="AD CredentialS"></Tab>
                    <Tab label="Network"></Tab>
                    <Tab label="OS"></Tab>
                    <Tab label="Application"></Tab>
                  </Tabs>
                </Box>
                {tabIndex === 0 && (
                  <Box sx={{ height: "calc(100vh - 225px)" }}>
                    <Attendance
                      key={`attendance-${classMode}-${rosterId}-${noRosterIdClassName}-${searchKey}`}
                      {...tabProps(0)}
                    />
                  </Box>
                )}
                {tabIndex === 1 && (
                  <Box sx={{ height: "calc(100vh - 225px)" }}>
                    <Hardware
                      key={`hardware-${classMode}-${rosterId}-${noRosterIdClassName}-${searchKey}`}
                      {...tabProps(1)}
                    />
                  </Box>
                )}
                {tabIndex === 2 && (
                  <Box sx={{ height: "calc(100vh - 225px)" }}>
                    <Credentials
                      key={`credentials-${classMode}-${rosterId}-${noRosterIdClassName}-${searchKey}`}
                      {...tabProps(2)}
                    />
                  </Box>
                )}
                {tabIndex === 3 && (
                  <Box sx={{ height: "calc(100vh - 225px)" }}>
                    <Network
                      key={`network-${classMode}-${rosterId}-${noRosterIdClassName}-${searchKey}`}
                      {...tabProps(3)}
                    />
                  </Box>
                )}
                {tabIndex === 4 && (
                  <Box sx={{ height: "calc(100vh - 225px)" }}>
                    <OperatingSystem
                      key={`os-${classMode}-${rosterId}-${noRosterIdClassName}-${searchKey}`}
                      {...tabProps(4)}
                    />
                  </Box>
                )}
                {tabIndex === 5 && (
                  <Box sx={{ height: "calc(100vh - 225px)" }}>
                    <Application
                      key={`application-${classMode}-${rosterId}-${noRosterIdClassName}-${searchKey}`}
                      {...tabProps(5)}
                    />
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
          <SnackBar snack={snack} snackReset={snackReset} />
        </Card>
      </ThemeProvider>

      <Dialog
        open={showDialog}
        onClose={handleDialogCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "8px",
          },
        }}
      >
        <DialogContent sx={{ pt: 0, pb: 2, px: 3 }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "27.5rem",
            }}
          >
            <WarningAmberRoundedIcon sx={{ color: "#F59E0B", fontSize: 45 }} />

            <IconButton
              onClick={handleDialogCancel}
              size="medium"
              sx={{ color: "#9e9e9e", marginLeft: "17.5rem" }}
            >
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Box>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#F59E0B",
              mb: 2,
              fontSize: "1.50rem",
              marginLeft: "12.75rem",
            }}
          >
            Unsaved Changes
          </Typography>

          <DialogContentText
            sx={{ color: "#6b7280", fontSize: "1.2rem", lineHeight: 1.6 }}
          >
            You have unsaved changes in{" "}
            <Box component="span" sx={{ fontWeight: 700, color: "grey" }}>
              {TAB_LABELS[tabIndex]}
            </Box>
            . What would you like to do?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3, gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleDialogDiscrad}
            width="50px"
            sx={{
              borderRadius: "10px",
              borderColor: "#3299FF",
              color: "#3299FF",
              fontWeight: 700,
              textTransform: "none",
              fontSize: "0.95rem",
              py: 1.2,
              "&:hover": {
                borderColor: "#3299FF",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Discard
          </Button>

          <Button
            variant="contained"
            onClick={handleDialogSave}
            disabled={!editAccess}
            width="50px"
            sx={{
              marginRight: "15.5rem",
              borderRadius: "10px",
              backgroundColor: "#3299FF",
              fontWeight: 700,
              textTransform: "none",
              fontSize: "0.95rem",
              py: 1.2,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#2878CC",
                boxShadow: "none",
              },
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
